import { gql } from '@apollo/client';
import type { ScanPromptInfo } from '../../scanResult';

// 与后端 BagMergeResultType 对齐：mutation 直接返回 BagMergeResultType，无外壳包裹
export const HANDLE_BAG_MERGE_EVENT = gql`
  mutation HandleBagMergeEvent($input: BagMergeInput!) {
    handleBagMergeEvent(input: $input) {
      success
      message
      mergeTaskId
      totalOrderCount
      skippedFinishedCount
      totalBagCount
      targetBagNumber
      bagBreakdown {
        bagId
        bagNumber
        orderCount
        isTarget
      }
      promptInfo {
        messageKey
        popupType
        title
        content
      }
    }
  }
`;

export interface BagMergeInput {
  sourceBagIds: number[];
  targetBagId: number;
}

export interface BagMergeBagBreakdownType {
  bagId: number;
  bagNumber: string;
  orderCount: number;
  isTarget: boolean;
}

export interface BagMergeResultType {
  success: boolean;
  message?: string | null;
  mergeTaskId: number;
  totalOrderCount: number;
  skippedFinishedCount: number;
  totalBagCount: number;
  targetBagNumber: string;
  bagBreakdown: BagMergeBagBreakdownType[];
  promptInfo?: ScanPromptInfo | null;
}

export interface HandleBagMergeEventResponse {
  handleBagMergeEvent: BagMergeResultType;
}

export interface HandleBagMergeEventVariables {
  input: BagMergeInput;
}
